import React from 'react';
import styled from 'styled-components';
import { Lock } from '@zocdoc-frontend-common/assets-icons';
import { Column } from '@zocdoc-frontend-common/styles-grid';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

const SecureLogo = () => {
    return (
        <SecureLogoWrapper data-test="header-secure-logo">
            <SecureIconWrapper>
                <SecureIcon />
            </SecureIconWrapper>
            <SecureText>Secure</SecureText>
        </SecureLogoWrapper>
    );
};

const SecureLogoWrapper = styled.div`
    margin-top: 16px;
    margin-bottom: 10px;

    ${breakpoint.small} {
        margin-top: 8px;
    }
`;

const SecureIconWrapper = styled.div`
    display: inline-block;
    width: 20px;

    ${breakpoint.small} {
        margin-right: 12px;
    }
`;

const SecureIcon = styled(Lock)`
    display: inline-block;
    height: 13px;
    width: 13px;

    ${breakpoint.small} {
        height: 20px;
        width: 20px;
    }
`;

const SecureText = styled(Column)`
    display: inline-block;
    font: 13px/1 ${FontFamily.SharpSansSemibold};
    padding-bottom: 0px;
    padding-top: 0px;
    vertical-align: top;
    width: 56px;

    ${breakpoint.small} {
        font-size: 15px;
        line-height: 20px;
        width: 88px;
    }
`;

export default SecureLogo;
